/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import emailjs from 'emailjs-com';

import { tab_modeles, tab_couleurs, tab_secu } from './Correspondances';
import { ConvSecu } from './Fonctions';

const options = ["Manuelle à cordelette", "Manuelle à slide", "Moteur solaire"]
const tab_env = ["Calme", "Bruyant", "Très bruyant"];

function SendMail(store_type, commande, compas, largeur, hauteur, couleur, environnement, securite, contacts, HorsNormes, computeenv, prix, orientation) {

	const templateParams = {
		store_type: tab_modeles[store_type],
		commande: options[commande],
		largeur: largeur,
		hauteur: hauteur,
		orientation: compas,
		couleur: store_type ? "N/A" : tab_couleurs[couleur],
		environnement: tab_env[environnement-1],
		securite: tab_secu[ConvSecu(securite, computeenv, orientation)[0]],
		verre_int: ConvSecu(securite, computeenv, orientation)[1],
		verre_ext: ConvSecu(securite, computeenv, orientation)[2],
		HorsNormes: HorsNormes ? '❌ Attention : configuration hors standards' : '✅ Configuration valide',
		prenom: contacts.prenom,
		nom: contacts.nom,
		codepostal: contacts.codepostal,
		email: contacts.email,
		recap: `StoreVision ${tab_modeles[store_type]} ${store_type ? '' : tab_couleurs[couleur]} — ${ConvSecu(securite, computeenv, orientation)[1]} / ${ConvSecu(securite, computeenv, orientation)[2]} — Commande ${options[commande]} — Dimensions (largeur x hauteur) : ${largeur} x ${hauteur} mm`,
		prix: prix
	};
	
	emailjs.send('service_3sqffml', 'template_public', templateParams, 'wZ4qqAfFsicxtfHFh');
}

export default SendMail;
